import _objectSpread from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { createTileLayerComponent, updateGridLayer, withPane } from '@react-leaflet/core';
import { TileLayer } from 'leaflet';
export var WMSTileLayer = createTileLayerComponent(function createWMSTileLayer(_ref, context) {
  var _ref$params = _ref.params,
      params = _ref$params === void 0 ? {} : _ref$params,
      url = _ref.url,
      options = _objectWithoutProperties(_ref, ["params", "url"]);

  return {
    instance: new TileLayer.WMS(url, _objectSpread(_objectSpread({}, params), withPane(options, context))),
    context: context
  };
}, function updateWMSTileLayer(layer, props, prevProps) {
  updateGridLayer(layer, props, prevProps);

  if (props.params != null && props.params !== prevProps.params) {
    layer.setParams(props.params);
  }
});